/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Week_BodyInputs */

const en_coaches_page_week_body = /** @type {(inputs: Coaches_Page_Week_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You only see hours that are really free, straight from each person's calendar. Tap one and the confirmation arrives at once.`)
};

const pl_coaches_page_week_body = /** @type {(inputs: Coaches_Page_Week_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widzisz tylko godziny, które naprawdę są wolne, prosto z kalendarza każdej osoby. Klikasz jedną, a potwierdzenie przychodzi od razu.`)
};

/**
* | output |
* | --- |
* | "You only see hours that are really free, straight from each person's calendar. Tap one and the confirmation arrives at once." |
*
* @param {Coaches_Page_Week_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_week_body = /** @type {((inputs?: Coaches_Page_Week_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Week_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_week_body(inputs)
	return en_coaches_page_week_body(inputs)
});